module.exports = __webpack_public_path__ + "e158a87994a2589284c98b7f4b448f9f.png";